import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AssessmentSyncDashboard from "./routes/AssessmentSyncDashboard";
import AssessmentCategoryMapping from "./routes/AssessmentCategoryMapping";
import GradingPeriodMapping from "./routes/GradingPeriodMapping";
import ClassGradingMapping from "./routes/ClassGradingMapping";

export default store => ({
  path: ":curriculum_id",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-assessmentSync" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    AssessmentSyncDashboard(store),
    AssessmentCategoryMapping(store),
    GradingPeriodMapping(store),
    ClassGradingMapping(store),
  ],
});
